import axios from "axios";
import { logout } from "../qcr-auth/slices/authSlice";
import store from "../store";

class APIService {
  constructor(baseURL) {
    this.axiosInstance = axios.create({
      baseURL,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    this.axiosInstance.interceptors.request.use((config) => {
      const token = store.getState().auth.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  getAuthToken() {
    const state = store.getState().auth.token;
    if (state !== undefined) return state.auth.token;
    return ""; // Return an empty string if token is undefined
  }

  //for get method
  async fetchData(endpoint, headers = {}) {
    try {
      const response = await this.axiosInstance.get(endpoint, { headers });
      return response;
    } catch (error) {
      if (error.response.status === 401) store.dispatch(logout());
    }
  }

  async postData(endpoint, data) {
    try {
      const response = await this.axiosInstance.post(endpoint, data);
      return response;
    } catch (error) {
      if (error.response.status === 401) store.dispatch(logout());
    }
  }

  async patchData(endpoint, data) {
    try {
      const response = await this.axiosInstance.patch(endpoint, data);
      return response;
    } catch (error) {
      if (error.response.status === 401) store.dispatch(logout());
    }
  }

  async deleteData(endpoint, data) {
    try {
      const response = await this.axiosInstance.delete(endpoint, data);
      return response;
    } catch (error) {
      if (error.response.status === 401) store.dispatch(logout());
    }
  }

  async putData(endpoint, data) {
    try {
      const response = await this.axiosInstance.put(endpoint, data);
      return response;
    } catch (error) {
      if (error.response.status === 401) store.dispatch(logout());
    }
  }
}

export default APIService;
